import EditTradeContext from "@shared/features/trades/EditTrade/EditTrade.context";
import { useTheme } from "styled-components";
import usePrecision from "@shared/common/Precision/usePrecision";
import { PrecisionType } from "@shared/types";
import { round } from "@shared/utils/numbers";
import { useContext } from "react";
import { getExtraOrderData } from "@shared/features/trades/common/utils";
import { EditOrderData } from "@shared/features/trades/EditTrade/types";

interface useOrderCardProps {
  order: EditOrderData;
  isEdit?: boolean;
}
const useOrderCard = ({ order, isEdit }: useOrderCardProps) => {
  const { weightedAverageEntryPrice, ordersData: responseData } =
    useContext(EditTradeContext) || {};
  const appTheme = useTheme();
  const precisionConfig = responseData?.precision;
  const { getPrecision } = usePrecision(undefined, precisionConfig);
  const precision = getPrecision(PrecisionType.PERCENT);
  const { price_coin: priceCoin, amount_coin: amountCoin } =
    responseData?.data || {};

  const amountChanged = isEdit && order.edit_amount !== order.amount;
  const quantityChanged = isEdit && order.edit_quantity !== order.quantity;
  const priceChanged = isEdit && order.edit_target_price !== order.target_price;
  const percentPrecision = Math.ceil(precision / 2);
  const currentRatio = round(
    100 * (isEdit ? order.edit_ratio : order.display_ratio),
    percentPrecision
  );
  const previousRatio = round(
    100 * (isEdit ? order.ratio : order.display_ratio),
    percentPrecision
  );
  const ratioChanged = isEdit && currentRatio !== previousRatio;

  const orderExtraData = getExtraOrderData(
    order,
    weightedAverageEntryPrice,
    percentPrecision
  );
  const showExtraData = orderExtraData.length > 0;

  return {
    appTheme,
    precisionConfig,
    amountChanged,
    quantityChanged,
    priceChanged,
    ratioChanged,
    orderExtraData,
    showExtraData,
    priceCoin,
    amountCoin,
    previousRatio,
    currentRatio,
  };
};

export default useOrderCard;
